"use strict";
exports.__esModule = true;
exports.getTooltipContentWidth = exports.formatValueForTooltip = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var numberjs_1 = require("@gooddata/numberjs");
var escape_1 = tslib_1.__importDefault(require("lodash/escape"));
var unescape_1 = tslib_1.__importDefault(require("lodash/unescape"));
var customEscape = function (str) { return str && escape_1["default"](unescape_1["default"](str)); };
function formatValueForTooltip(val, format, separators) {
    if (!format) {
        return "" + val;
    }
    var formattedObject = numberjs_1.colors2Object(numberjs_1.numberFormat(val, format, undefined, separators));
    return customEscape(formattedObject.label);
}
exports.formatValueForTooltip = formatValueForTooltip;
function getTooltipContentWidth(isFullScreenTooltip, chartWidth, tooltipMaxWidth) {
    return isFullScreenTooltip ? chartWidth : Math.min(chartWidth, tooltipMaxWidth);
}
exports.getTooltipContentWidth = getTooltipContentWidth;
//# sourceMappingURL=format.js.map